import { createApp } from 'vue'
import App from './Article.vue'
import axios from '/src/components/NovaAxios.js';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Vue3Toasity from 'vue3-toastify';

window._nova_root_app = createApp(App)
    .use(
        Vue3Toasity,
        {
            dangerouslyHTMLString: true,
        }, // global options type definition --> ToastContainerOptions
    );


window._nova_root_app.config.devtools = true;
// Call any component registrations
if (window._nova_component_registration) {
    for (let reg of window._nova_component_registration) {
        reg();
    }
}

// Store references to the original functions
const originalAddEventListener = window.addEventListener;
const originalRemoveEventListener = window.removeEventListener;

// Wrap the addEventListener function
window.addEventListener = function (event, handler, options) {
    // Check if el is a DOM element
    const isDOMElement = (typeof arguments[0] !== 'string') && (arguments[0] instanceof EventTarget);

    // If el is a DOM element, call the module's addEventListener function
    if (isDOMElement) {
        addEventListener.apply(this, arguments);
        return;
    }

    // Call the original addEventListener function
    originalAddEventListener.apply(this, arguments);
};

// Wrap the removeEventListener function
window.removeEventListener = function (event, handler, options) {
    // Check if el is a DOM element
    const isDOMElement = (typeof arguments[0] !== 'string') && (arguments[0] instanceof EventTarget);

    // If el is a DOM element, call the module's removeEventListener function
    if (isDOMElement) {
        removeEventListener.apply(this, arguments);
        return;
    }

    // Call the original removeEventListener function
    originalRemoveEventListener.apply(this, arguments);
};

window._nova_root_vue_vm = window._nova_root_app.mount('#NovaVueAppRootTemplate');
